import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedDoctorRouteProps {
  children: React.ReactNode;
}

const ProtectedDoctorRoute: React.FC<ProtectedDoctorRouteProps> = ({ children }) => {
  const { user, loading, userRole } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (userRole !== 'doctor') {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};

export default ProtectedDoctorRoute;
